import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { INVOICE_TABLE_SORT_KEYS, INVOICE_TABLE_TAB_FILTERS } from '@css-xp/ppc-constants';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { INVOICE_TABLE_UTILS } from '@css-xp/ppc-utils';
import { fetchInvoicesForTransactionAccountPPC } from './queries/ans-queries/fetch-invoices-for-transaction-account-ppc';

const defaultSortOptions = {
  sortFields: [INVOICE_TABLE_SORT_KEYS.CREATED_DATE, INVOICE_TABLE_SORT_KEYS.ID],
  sortFieldsDirections: [generatedTypesNew.SortDirection.DESC, generatedTypesNew.SortDirection.DESC],
};

export const useFetchInvoicesForTransactionAccountPPCQuery = ({
  txaId,
  searchOptions = INVOICE_TABLE_UTILS.getCommonQuerySearchOptions(defaultSortOptions, {}),
  filterOptions = {
    and: [{ or: INVOICE_TABLE_TAB_FILTERS }],
  },
  skipOption = false,
}: {
  txaId: string;
  searchOptions?: generatedTypesNew.SearchOptions;
  filterOptions?: generatedTypesNew.InvoicesFilterOptions;
  skipOption?: boolean;
}) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchInvoicesForTransactionAccountPpcQuery,
    generatedTypesNew.FetchInvoicesForTransactionAccountPpcQueryVariables
  >(fetchInvoicesForTransactionAccountPPC, {
    variables: {
      id: txaId,
      searchOptions,
      filterOptions,
    },
    displayName: 'fetchInvoicesForTransactionAccountPPC',
    skip: skipOption,
    client: ansClient,
  });
};
